(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = window.VALENI_OFFER;
  const data = JSON.parse($('#commerce-data')?.textContent || '{}');
  const preview = data.preview === true;
  const currency = data.currency || 'PLN';
  const money = value => new Intl.NumberFormat(document.documentElement.lang === 'de' ? 'de-DE' : 'pl-PL', {style:'currency', currency}).format(value / 100);
  const make = (tag, text, cls) => { const el = document.createElement(tag); if (text !== undefined) el.textContent = text; if (cls) el.className = cls; return el; };
  function bundleBadge(text, discount = false) {
    const badge = make('span', undefined, 'bundle-badge');
    if (!text) { badge.setAttribute('aria-hidden','true'); return badge; }
    const crown = document.createElementNS('http://www.w3.org/2000/svg','svg');
    crown.setAttribute('viewBox','0 0 24 24'); crown.setAttribute('aria-hidden','true');
    const path = document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d',discount ? 'M3 3h9l9 9-9 9-9-9Z' : 'M3 6 8 10 12 3 16 10 21 6 19 18H5ZM5 20h14');
    path.setAttribute('fill','currentColor'); crown.append(path);
    if (discount) { const symbol = document.createElementNS('http://www.w3.org/2000/svg','text'); symbol.setAttribute('x','11'); symbol.setAttribute('y','15'); symbol.setAttribute('text-anchor','middle'); symbol.setAttribute('font-size','13'); symbol.setAttribute('fill','#876119'); symbol.textContent='%'; crown.append(symbol); }
    badge.append(crown,make('span',text)); return badge;
  }
  function pricePresentation(total, reference, tag = 'b') {
    const prices = make('span', undefined, 'bundle-prices');
    prices.append(make(tag, money(total)));
    if (reference > total) {
      const comparison = make('span', undefined, 'price-comparison');
      comparison.append(make('s',money(reference),'bundle-regular'),make('span',`${Math.round((1-total/reference)*100)}% TANIEJ!`,'bundle-saving discount-badge'));
      prices.append(comparison);
    }
    return prices;
  }
  const menu = $('#mobile-menu'), menuButton = $('[data-menu-toggle]');
  function closeMenu() { menu.hidden = true; menuButton.setAttribute('aria-expanded','false'); }
  menuButton?.addEventListener('click', () => { menu.hidden = !menu.hidden; menuButton.setAttribute('aria-expanded', String(!menu.hidden)); });
  menu?.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { closeMenu(); menuButton.focus(); } });
  const sticky = $('.mobile-sticky'), faq = $('#faq'), purchase = $('#zakup');
  if (sticky && faq && purchase) {
    document.body.append(sticky);
    const form = $('#purchase-form');
    const updateSticky = () => {
      const bounds = form.getBoundingClientRect();
      const headerBottom = $('.site-header')?.getBoundingClientRect().bottom || 0;
      sticky.hidden = faq.getBoundingClientRect().top >= innerHeight || (bounds.bottom > headerBottom && bounds.top < innerHeight);
    };
    const observer = new IntersectionObserver(updateSticky);
    observer.observe(faq);observer.observe(form);observer.observe($('#oferta'));
    addEventListener('resize', updateSticky);
    updateSticky();
    sticky.addEventListener('click', event => {
      event.preventDefault();
      purchase.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    });
  }
  const slides = $('.slides');
  if (slides) {
    let current = 0;
    let autoTimer;
    function stopAuto() { clearInterval(autoTimer); autoTimer = null; }
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) autoTimer = setInterval(() => { if (!document.hidden && !document.querySelector('dialog[open]')) go(current + 1); }, 5000);
    // Any intentional manual navigation permanently ends discovery autoplay.
    $('.gallery').addEventListener('pointerdown', stopAuto, {once:true});
    slides.addEventListener('wheel', stopAuto, {passive:true, once:true});
    slides.addEventListener('touchstart', stopAuto, {passive:true, once:true});
    const thumbs = $$('[data-thumb]');
    function go(index) { current = (index + thumbs.length) % thumbs.length; slides.scrollTo({ left: slides.clientWidth * current, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    $('[data-prev]').addEventListener('click', () => { stopAuto(); go(current - 1); });
    $('[data-next]').addEventListener('click', () => { stopAuto(); go(current + 1); });
    thumbs.forEach((b,i) => b.addEventListener('click', () => { stopAuto(); go(i); }));
    slides.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) { e.preventDefault(); stopAuto(); go(current + (e.key === 'ArrowLeft' ? -1 : 1)); } });
    slides.addEventListener('scroll', () => {
      current = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach((b,i) => b.setAttribute('aria-pressed',String(i === current)));
      $('[data-counter]').textContent = `${String(current+1).padStart(2,'0')} / 07`;
    }, {passive:true});
    new ResizeObserver(() => slides.scrollTo({left:current * slides.clientWidth,behavior:'instant'})).observe(slides);
  }
  const drawer = $('.cart-drawer');
  const items = $('[data-cart-items]'), cartStatus = $('[data-cart-status]'), checkout = $('[data-checkout]');
  let marketChanged = false;
  let busy = false, cartValid = false, previousFocus, demoItems = [];
  if (preview) { try { demoItems = JSON.parse(sessionStorage.getItem('valeni-preview-cart') || '[]'); } catch {} }
  const variants = preview ? config.sizes.map(s => ({id:`demo-${s.key}`, title:s.label, options:[s.label], price:config.unitPrice, available:true})) : (data.variants || []);
  const findVariant = size => window.VALENI_VARIANTS.find(variants, size);
  const initialSize = config.sizes.find(s => findVariant(s.key)?.available)?.key || config.sizes[0].key;
  let bundleId = 'single';
  // Each offer retains its own selections, including hidden sets when switching.
  const selections = Object.fromEntries(config.bundles.map(bundle => [bundle.id, Array(bundle.quantity).fill(initialSize)]));
  const selectedBundle = () => config.bundles.find(b => b.id === bundleId);
  function renderSizeSelectors() {
    const host = $('[data-set-sizes]');
    if (!host || host.dataset.bundle === bundleId) return;
    host.dataset.bundle = bundleId;
    host.replaceChildren();
    selections[bundleId].forEach((size, index) => {
      const group = make('fieldset', undefined, 'set-size-group');
      group.append(make('legend', window.valeniT('js_piece', {n:index + 1})));
      const options = make('div', undefined, 'size-options');
      config.sizes.forEach(option => {
        const label = make('label'), input = make('input'), surface = make('span');
        input.type = 'radio'; input.name = `size-${index}`; input.value = option.key;
        input.dataset.setIndex = index;
        input.setAttribute('aria-label', window.valeniT('js_piece', {n:index + 1}) + ': ' + option.label);
        surface.append(make('strong', option.label));
        label.append(input, surface); options.append(label);
      });
      group.append(options); host.append(group);
    });
  }
  function offerUpdate() {
    if (!$('#purchase-form')) return;
    renderSizeSelectors();
    $$('[data-set-index]').forEach(input => {
      input.checked = selections[bundleId][Number(input.dataset.setIndex)] === input.value;
      input.disabled = !findVariant(input.value)?.available;
    });
    const quote = selectedBundle();
    const verified = quote.displayable;
    $('[data-unit-price]').textContent = verified ? money(quote.totalPrice) : window.valeniT('js_price_unavailable');
    const compareTotal = config.unitPrice * quote.quantity;
    $('[data-offer-discount]').textContent = quote.discountLabel;
    $('[data-offer-discount]').hidden = !verified;
    const galleryBadge = $('[data-gallery-discount]');
    galleryBadge.textContent = quote.discountLabel; galleryBadge.hidden = !verified;
    const reference = document.querySelector('.price-line s');
    if (reference) { reference.textContent = money(compareTotal); reference.hidden = !verified; reference.removeAttribute('aria-label'); }
    const historical = $('.lowest-price');
    if (historical) { historical.textContent = window.valeniT('js_historical_low', {price:money(quote.historicalLow)}); historical.hidden = currency !== 'PLN'; }
    if (window.VALENI_PRICING.error) $('[data-purchase-status]').textContent = window.VALENI_PRICING.error;
    const host = $('[data-bundles]');
    if (!host.children.length) config.bundles.forEach(bundle => {
      const label = make('label'), input = make('input'), surface = make('span', undefined, 'bundle-surface');
      input.type = 'radio'; input.name = 'bundle'; input.value = bundle.id;
      const badge = bundleBadge(bundle.id === 'double' ? window.valeniT('js_popular') : bundle.id === 'family' ? window.valeniT('js_best_value') : '', bundle.id === 'family');
      const prices = make('span', undefined, 'bundle-prices');
      prices.append(make('s', '', 'bundle-regular'), make('b')); 
      const artwork = make('img', undefined, 'bundle-art'); artwork.src = new URL(`bundle-${data.productKey}-${bundle.id}.webp`, document.querySelector('script[src*="christmas.js"]').src).href; artwork.alt = ''; artwork.width = 150; artwork.height = 100;
      const text = make('span', undefined, 'bundle-text');
      text.append(make('strong', bundle.quantity === 4 ? window.valeniT('js_family') : bundle.label));

      const saving = make('span', undefined, 'bundle-savings-copy');
      saving.append(make('span', window.valeniT('js_savings_label')), make('strong'));
      surface.append(badge, text, artwork, prices, saving, make('span', bundle.discountLabel, 'bundle-saving discount-badge'));
      label.append(input, surface); host.append(label);
    });
    config.bundles.forEach(bundle => {
      const card = host.querySelector(`input[value="${bundle.id}"]`).closest('label');
      const regular = card.querySelector('.bundle-regular');
      regular.textContent = money(config.unitPrice * bundle.quantity); regular.hidden = !bundle.displayable;
      card.querySelector('.bundle-prices b').textContent = bundle.displayable ? money(bundle.totalPrice) : window.valeniT('js_price_unavailable');
      card.querySelector('.bundle-savings-copy strong').textContent = bundle.displayable ? money(config.unitPrice * bundle.quantity - bundle.totalPrice) : '';
      card.querySelector('.bundle-savings-copy').hidden = !bundle.displayable;
      card.querySelector('.bundle-saving').hidden = !bundle.displayable;
    });
    $$('input[name=bundle]').forEach(input => { input.checked = input.value === bundleId; });
    $('[data-purchase]').setAttribute('aria-busy', String(busy));
    $('[data-bundle-reference]').hidden = true;
    const priceMatches = preview || selections[bundleId].every(size => Number(findVariant(size)?.price) === config.unitPrice);
    const available = selections[bundleId].every(size => findVariant(size)?.available) && priceMatches;
    $('[data-purchase]').disabled = busy || marketChanged || !available;
    if (!available) $('[data-purchase-status]').textContent = !priceMatches ? window.valeniT('js_price_confirmation') : window.valeniT('js_variant_unavailable');
  }
  $('#purchase-form')?.addEventListener('change', e => {
    if (e.target.hasAttribute('data-set-index')) selections[bundleId][Number(e.target.dataset.setIndex)] = e.target.value;
    if (e.target.name === 'bundle') { const previous = selections[bundleId]; bundleId = e.target.value; previous.slice(0, selections[bundleId].length).forEach((size,i) => selections[bundleId][i] = size); }
    $('[data-purchase-status]').textContent = ''; offerUpdate();
  });
  function lock(value) {
    busy = value;
    drawer.setAttribute('aria-busy',String(value));
    $$('button',items).forEach(b => b.disabled = value || b.dataset.boundary === 'true');
    $$('button,select', $('[data-cart-bundles]')).forEach(b => b.disabled = value);
    checkout.disabled = preview || value || !cartValid;
    $('[data-cart-refresh]').disabled = value;
    offerUpdate();
  }
  async function request(url, body) {
    const response = await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},...(body ? {method:'POST',body:JSON.stringify(body)} : {}),signal:AbortSignal.timeout(15000)});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : window.valeniT('js_cart_update_error'));
    return result;
  }
  function demoCart() {
    for (const [key,definition] of Object.entries(window.VALENI_CATALOG)) {
      const rows = demoItems.filter(row=>row.product_id===key), quantity = rows.reduce((n,row)=>n+row.quantity,0);
      const bundle = definition.bundles.find(b=>b.quantity===quantity);
      let discount = bundle ? definition.unitPrice * quantity - bundle.expectedTotal : 0;
      rows.forEach(row=>{ const reduction=Math.min(discount,definition.unitPrice*row.quantity); row.original_line_price=definition.unitPrice*row.quantity; row.final_line_price=row.original_line_price-reduction; discount-=reduction; });
    }
    sessionStorage.setItem('valeni-preview-cart', JSON.stringify(demoItems)); return {items:demoItems,item_count:demoItems.reduce((n,i)=>n+i.quantity,0),total_price:demoItems.reduce((n,i)=>n+i.final_line_price,0),currency:'PLN',original_total_price:demoItems.reduce((n,i)=>n+i.original_line_price,0),total_discount:demoItems.reduce((n,i)=>n+i.original_line_price-i.final_line_price,0)}; }
  const productRows = cart => cart.items.filter(item => preview ? item.product_id === 'projector' : String(item.product_id) === String(data.productId));
  const validQuantity = quantity => quantity === 0 || [1,2,4].includes(quantity);
  const normalizeQuantity = quantity => quantity >= 3 ? 4 : Math.max(0, quantity);
  function offerDiscrepancy(cart) {
    const rows = productRows(cart), quantity = rows.reduce((sum,row) => sum + row.quantity, 0);
    if (!rows.length) return false;
    const actual = rows.reduce((sum,row) => sum + row.final_line_price, 0);
    const original = rows.reduce((sum,row) => sum + (row.original_line_price ?? config.unitPrice * row.quantity), 0);
    const hasCartDiscount = (cart.cart_level_discount_applications || []).length > 0;
    const total = rows.length === cart.items.length ? cart.total_price : actual;
    return !validQuantity(quantity) || !window.valeniAcceptQuote(quantity,total,original / quantity,cart.currency) || (hasCartDiscount && rows.length !== cart.items.length);
  }
  async function alignBundleLabels(cart) {
    const quantity = productRows(cart).reduce((n,row)=>n+row.quantity,0);
    const bundle = config.bundles.find(b=>b.quantity===quantity);
    if (!bundle) return cart;
    for (let attempt=0;attempt<8;attempt++) {
      const row = productRows(cart).find(row=>row.properties?.Zestaw && (row.properties.Zestaw!==bundle.label || row.properties._valeni_bundle!==bundle.id));
      if (!row) return cart;
      cart = await request(data.changeUrl,{id:row.key,quantity:row.quantity,properties:{...row.properties,Zestaw:bundle.label,_valeni_bundle:bundle.id}});
    }
    throw Error('Nie udało się uzgodnić pakietu w koszyku. Odśwież koszyk.');
  }
  async function setProductQuantity(cart, quantity) {
    quantity = normalizeQuantity(quantity);
    const rows = productRows(cart);
    if (!rows.length) return cart;
    const updates = {};
    rows.forEach((row,index) => { updates[row.key] = index === 0 ? quantity : 0; });
    return alignBundleLabels(await request(data.cartUrl+'/update.js',{updates}));
  }
  async function normalizeCart(cart) {
    const rows = productRows(cart), quantity = rows.reduce((sum,row) => sum + row.quantity,0);
    const signatures = new Set(rows.map(row => JSON.stringify(row.properties || {})));
    if (!validQuantity(quantity) || signatures.size > 1) cart = await setProductQuantity(cart,quantity);
    return alignBundleLabels(cart);
  }
  let pricingMismatch = false, currentCart = null;
  function cartMessage(message = '') {
    if (marketChanged) return;
    cartStatus.classList.toggle('cart-status-error', pricingMismatch || marketChanged);
    cartStatus.textContent = pricingMismatch ? window.valeniT('js_cart_mismatch') : message;
  }
  function renderCart(cart) {
    currentCart = cart;
    marketChanged = !preview && cart.currency !== currency;
    if (marketChanged) { cartValid = false; checkout.disabled = true; cartStatus.classList.add('cart-status-error'); cartStatus.textContent = window.valeniT('js_market_changed'); $('[data-cart-refresh]').hidden = false; return; }
    items.replaceChildren();
    $$('[data-count]').forEach(el => el.textContent = cart.item_count);
    drawer.classList.toggle('is-empty', !cart.items.length);
    $('.cart-bottom').hidden = !cart.items.length;
    $('.cart-empty-actions').hidden = !!cart.items.length;
    if (!cart.items.length) items.append(make('p',window.valeniT('js_cart_empty'),'empty-cart'));
    const ownedRows = productRows(cart);
    const displayItems = cart.items.filter(item => !ownedRows.includes(item));
    if (ownedRows.length) displayItems.unshift({...ownedRows[0],
      quantity:ownedRows.reduce((n,row)=>n+row.quantity,0),
      original_line_price:ownedRows.reduce((n,row)=>n+(row.original_line_price ?? config.unitPrice*row.quantity),0),
      final_line_price:ownedRows.reduce((n,row)=>n+row.final_line_price,0),
      line_level_discount_allocations:ownedRows.flatMap(row=>row.line_level_discount_allocations || [])});
    for (const item of displayItems) {
      const row = make('article',undefined,'cart-item');
      const owned = ownedRows.some(row => row.key === item.key);
      const bundle = config.bundles.find(b => b.quantity === item.quantity);
      if (item.image) { const img = make('img'); img.src = owned && bundle ? new URL(`bundle-projector-${bundle.id}.png`,document.querySelector('script[src*="christmas.js"]').src).href : item.image; img.alt = item.product_title; img.width = 76; img.height = 76; row.append(img); }
      const info = make('div'); info.append(make('h3',item.product_title),make('p',owned && bundle ? bundle.label : item.variant_title || '', 'cart-bundle-label'));


      const controls = make('div',undefined,'quantity-controls');
      function control(text, quantity, label, cls) { const b = make('button',text,cls); b.type='button'; b.dataset.key=item.key; b.dataset.quantity=quantity; b.setAttribute('aria-label',`${label}: ${item.product_title}, ${item.variant_title || ''}`); return b; }
      const quantity = owned ? productRows(cart).reduce((n,row) => n + row.quantity,0) : item.quantity;
      const minus = control('−',quantity >= 4 ? 2 : 1,window.valeniT('js_decrease')); minus.dataset.boundary = String(quantity === 1); minus.disabled = quantity === 1; controls.append(minus);
      controls.append(make('span',quantity));
      const plus = control('+',quantity === 1 ? 2 : 4,window.valeniT('js_increase')); plus.dataset.boundary = String(quantity === 4); plus.disabled = quantity === 4; controls.append(plus);
      const entry = (data.catalog || []).find(entry=>String(entry.productId)===String(item.product_id));
      const definition = window.VALENI_CATALOG[preview ? item.product_id : entry?.key];
      const reference = item.original_line_price ?? config.unitPrice * item.quantity;
      const price = pricePresentation(item.final_line_price, reference, 'strong');
      price.classList.add('cart-line-prices');
      if (owned && bundle) { const badge = price.querySelector('.discount-badge'); if (badge) badge.textContent = bundle.discountLabel; }
      const actions = make('div',undefined,'cart-item-actions');
      const remove = control('',0,window.valeniT('js_remove'),'remove-item'); remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg>'; actions.append(controls,remove);
      info.append(price,actions);
      row.append(info);
      items.append(row);
    }
    const regular = cart.original_total_price ?? config.unitPrice * cart.item_count;
    $('[data-cart-regular]').textContent = money(regular);
    $('[data-cart-saving]').textContent = '−' + money(regular - cart.total_price);
    $('[data-cart-total-regular]').textContent = money(regular);
    $('[data-cart-total]').textContent = money(cart.total_price);
    const totalBundle = config.bundles.find(b => b.quantity === cart.item_count);
    const coupon = $('[data-cart-coupon]');
    coupon.textContent = totalBundle?.discountLabel || '';
    coupon.hidden = !totalBundle || !cart.item_count;
    $('[data-delivery-estimate]').textContent = window.valeniDeliveryEstimate();

    pricingMismatch = offerDiscrepancy(cart);
    cartValid = cart.item_count > 0 && !pricingMismatch; checkout.disabled = preview || busy || !cartValid;
    offerUpdate();
  }
  function showDrawer() { if (!drawer.open) { previousFocus = document.activeElement; drawer.showModal(); } }
  async function refresh() {
    if (busy) return;
    if (marketChanged) { location.reload(); return; }
    lock(true); cartStatus.textContent = window.valeniT('js_cart_loading'); $('[data-cart-refresh]').hidden = true;
    try { renderCart(preview ? demoCart() : await normalizeCart(await request(data.cartUrl+'.js'))); cartMessage(); }
    catch(e) { cartValid = false; cartStatus.classList.add('cart-status-error'); cartStatus.textContent = window.valeniT('js_cart_load_error'); $('[data-cart-refresh]').hidden = false; }
    finally { lock(false); }
  }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', () => { showDrawer(); refresh(); }));
  $('[data-cart-close]').addEventListener('click', () => drawer.close());
  $('[data-empty-return]').addEventListener('click', event => {
    const offer = $('#oferta');
    if (offer) { event.preventDefault(); drawer.close(); offer.scrollIntoView({behavior:'smooth',block:'start'}); }
  });
  drawer.addEventListener('close', () => previousFocus?.focus({preventScroll:true}));
  drawer.addEventListener('click', e => { const r=drawer.getBoundingClientRect(); if(e.target===drawer && (e.clientX<r.left || e.clientX>r.right)) drawer.close(); });
  $('[data-cart-refresh]').addEventListener('click',refresh);
  $('[data-preview-note]').hidden = !preview;
  let checkoutVerified = false;
  $('[data-checkout-form]').addEventListener('submit', async e => {
    if (checkoutVerified) return;
    e.preventDefault();
    if (preview || busy || !cartValid) return;
    lock(true);
    try {
      renderCart(await normalizeCart(await request(data.cartUrl+'.js')));
      cartMessage();
      if (cartValid) {
        checkoutVerified = true;
        lock(false);
        e.target.requestSubmit(checkout);
      }
    } catch { cartValid = false; cartMessage('Nie udało się potwierdzić koszyka. Spróbuj ponownie.'); }
    finally { lock(false); }
  });
  $('#purchase-form')?.addEventListener('submit',async e => {
    e.preventDefault(); if(busy) return;
    const bundle = selectedBundle();
    if (!preview && (marketChanged || selections[bundleId].some(size => Number(findVariant(size)?.price) !== config.unitPrice))) return;
    let lineItems;
    try { lineItems = window.VALENI_VARIANTS.lineItems(variants, selections[bundleId], bundle); }
    catch(error) { $('[data-purchase-status]').textContent = error.message; return; }
    const status=$('[data-purchase-status]'); lock(true); status.textContent=window.valeniT('js_adding');
    let added=false;
    try {
      if (preview) {
        demoItems = demoItems.filter(row => row.product_id !== data.productKey);
        lineItems.forEach(line => {
          const variant = variants.find(v => v.id === line.id);
          const key = `${data.productKey}:${variant.id}:${bundle.id}`, existing = demoItems.find(i => i.key === key);
          if (existing) { existing.quantity += line.quantity; existing.final_line_price = existing.quantity * variant.price; }
          else demoItems.push({key, id:line.id, variant_id:line.id, product_id:data.productKey, product_title:config.name, variant_title:variant.title,
            quantity:line.quantity, final_line_price:variant.price * line.quantity, image:data.previewImage, properties:line.properties});
        });
        renderCart(demoCart());
      } else {
        const fresh = await request(data.cartUrl+'.js');
        if (productRows(fresh).length) await setProductQuantity(fresh,bundle.quantity);
        else await request(data.addUrl,{items:lineItems});
        added=true;
        renderCart(await normalizeCart(await request(data.cartUrl+'.js')));
      }
      status.textContent=preview ? window.valeniT('js_added_preview') : window.valeniT('js_added');
      cartMessage(preview ? window.valeniT('js_preview_prices') : ''); showDrawer();
    } catch(error) {
      cartValid=false;
      status.textContent=added ? window.valeniT('js_added_refresh') : (error.name==='TimeoutError' ? window.valeniT('js_add_timeout') : error.message);
      if(added) { showDrawer(); cartStatus.textContent=status.textContent; $('[data-cart-refresh]').hidden=false; }
    } finally { lock(false); }
  });
  items.addEventListener('click',async e => {
    const button=e.target.closest('[data-key]'); if(!button || busy) return;
    const key=button.dataset.key,quantity=Number(button.dataset.quantity); if (!validQuantity(quantity)) return; lock(true);
    try {
      if(preview) { const item=demoItems.find(i=>i.key===key); if(quantity===0) demoItems=demoItems.filter(i=>i.key!==key); else { const price=item.final_line_price/item.quantity; item.quantity=quantity; item.final_line_price=price*quantity; } renderCart(demoCart()); }
      else { const fresh = await request(data.cartUrl+'.js'); const row = fresh.items.find(item => item.key === key); if (!row) throw Error('Koszyk zmienił się. Odśwież go.'); renderCart(productRows(fresh).includes(row) ? await setProductQuantity(fresh,quantity) : await request(data.changeUrl,{id:key,quantity})); }
      cartMessage(window.valeniT('js_cart_updated')); $('[data-cart-refresh]').hidden=true;
    } catch(error) { cartValid=false; cartStatus.classList.add('cart-status-error'); cartStatus.textContent=window.valeniT('js_change_error'); $('[data-cart-refresh]').hidden=false; }
    finally { lock(false); ($$('[data-key]',items).find(b=>b.dataset.key===key) || $('[data-cart-close]')).focus(); }
  });
  const policy=$('.policy-dialog');
  $$('[data-preview-policy]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault(); $('#policy-title').textContent=a.textContent; policy.showModal();}));
  $('[data-policy-close]').addEventListener('click',()=>policy.close());
  if ($('#purchase-form')) window.valeniLoadQuotes().then(offerUpdate);
  offerUpdate();
  if(!preview) refresh(); else renderCart(demoCart());
  if (location.pathname.replace(/\/$/,'') === data.cartUrl?.replace(/\/$/,'')) showDrawer();
  addEventListener('pageshow',e=>{if(e.persisted) { checkoutVerified = false; refresh(); }});
})();
